import axios from "axios";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getPlansAPI } from "../../redux/features/authSlice";

const PlansCard = () => {
  const [plans, setPlans] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const response = await dispatch(getPlansAPI(token)).unwrap();
        // const mappedPlans =
        //   response?.data?.map((plan) => ({
        //     id: plan.id,
        //     type: plan.name,
        //     description: plan.description,
        //     price: `$${plan.price}`,
        //     duration: `/per ${plan.plan_type}`,
        //     isActive: false,
        //     features: plan.services,
        //     status: plan.status,
        //   })) || [];
        setPlans(response.data);
        // setPlans(mappedPlans);
      } catch (error) {
        console.error("Error fetching pricing plans:", error);
        toast.error(
          error?.message || "Failed to fetch pricing plans. Please try again.",
          {
            position: "top-center",
          }
        );
      }
    };
    fetchPlans();
  }, [dispatch, token]);

  const handlePlanSelect = (plan) => {
    if (plan.isActive) {
      toast.error("This plan is already active.", { position: "top-center" });
    } else {
      const checkoutPath = window.location.pathname.includes('manage-subscription') ? "/student-checkout" : "/checkout";
      navigate(checkoutPath, { state: { plan } });
    }
  };

  // Slick Slider settings
  const sliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      <div className="plan-wrapper px-15 w-100">
        <div className="plan-header text-center mb-25 mx-auto">
          <h1 className="ah-heading-01 fw-bold text-black mb-12">
            Pricing Plan
          </h1>
          <p className="ah-text-base fw-semibold mb-0">
            Share your files with us—whether they're images, videos, recordings,
            or text messages. We'll handle everything for you.
          </p>
        </div>
        <Slider {...sliderSettings} className="plan-card-wrapper">
          {plans.map((plan) => (
            <div
              key={plan?.id}
              className={`plan-card ${
                plan?.status === "active"? "active-plan" : ""
              } py-15 py-sm-25 py-md-35 py-lg-50 px-12 px-sm-20 px-md-25 px-lg-38`}
            >
              <div>
                <span className="text-uppercase bg-theme text-white py-8 px-25 rounded-5 d-inline-block mb-12 ah-text-base fw-semibold">
                  {plan?.plan_type}
                </span>
                <p className="ah-text-base black-100-60 mb-10 mb-sm-15">
                  {plan?.description}
                </p>
                <div className="mb-10 mb-sm-15 mb-md-20 mb-lg-30">
                  <span className="price ah-heading-01 fw-semibold">
                    {plan?.price}
                    <span className="ah-text-base fw-normal text-capitalize">
                      /{plan?.plan_type}
                    </span>
                  </span>
                </div>
                <button
                  className="btn btn-primary no-shadow w-100 rounded-5 ah-text-base fw-semibold"
                  type="button"
                  onClick={() => handlePlanSelect(plan)}
                  disabled={plan?.status === "active"}
                >
                  {plan?.status === "inactive"
                    ? "Subscribe Now"
                    : plan.status === "active"
                    ? "Subscribed"
                    : "Pending"}
                </button>
              </div>
              <div className="plan-spacer my-10 my-sm-20 my-md-30 my-lg-40"></div>
              <div className="plan-include-wrapper">
                <h5 className="ah-text-md fw-bold mb-12">PLAN INCLUDES</h5>
                <ul className="list-unstyled text-capitalize plan-item mb-0">
                  {plan.services.map((service) => (
                    <li key={service?.id} className="d-flex align-items-center">
                      {service?.enabled ? (
                        <span className="checkmark rounded-circle d-flex justify-content-center align-items-center flex-shrink-0"></span>
                      ) : (
                        <span className="crossmark rounded-circle d-flex justify-content-center align-items-center flex-shrink-0"></span>
                      )}
                      <span className="plan-item-text ah-text-base fw-normal ms-12">
                        {service?.name}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </>
  );
};

export default PlansCard;
